export const MAX_AUDIO_SIZE = 75 * Math.pow(10, 6);
